import { Component, useState } from "react";
import { useForm } from "../../../hooks/useForm";
import BaseModal from "../Base-modal";
import Input from "../../../blocks/Input";
import './payment-modal.css'
import { useEffect } from "react";
import { useSnackbar } from 'notistack'
import { ajax } from "../../../scripts/helper";
import utils from "../../../scripts/utils";
import context from "../../../scripts/context";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import dayjs, { Dayjs } from 'dayjs';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';







const Content = ({ closeModal, showModal, onFilter, onChangeInput }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [statusValue, setStatusValue] = useState()
  const [inputStatusValue, setInputStatusValue] = useState('');
  const [statusOptions, setStatusOptions] = useState([
    { label: 'CREATED', data: { label: 'CREATED' } },
    { label: 'PAID', data: { label: 'PAID' } },
    { label: 'USER_FAILED', data: { label: 'USER_FAILED' } },
    { label: 'SERVER_FAILED', data: { label: 'SERVER_FAILED' } },
    { label: 'SEND_TO_PGW', data: { label: 'SEND_TO_PGW' } },
    { label: 'BLOCKED', data: { label: 'BLOCKED' } },
  ])
  const [currencyValue, setCurrencyValue] = useState()
  const [inputCurrencyValue, setInputCurrencyValue] = useState('');
  const [currencyOptions, setCurrencyOptions] = useState([]);

  const [userValue, setUserValue] = useState()
  const [inputUserValue, setInputUserValue] = useState('');
  const [userOptions, setUserOptions] = useState([]);

  const [approveUserValue, setApproveUserValue] = useState()
  const [inputApproveUserValue, setInputApproveUserValue] = useState('');
  const [approveUserOptions, setApproveUserOptions] = useState([]);

  const [officeValue, setOfficeValue] = useState()
  const [inputOfficeValue, setInputOfficeValue] = useState('');
  const [officeOptions, setOfficeOptions] = useState([]);
  const [inputFields, handleChange, setInputFields] = useForm(context.getPaymentInputFilter(), onChangeInput)


  const handleFromDatepicker = (e) => {

    const newValue = {
      ...inputFields,
      validityFrom: {
        ...inputFields.validityFrom,
        value: e
      }
    }
    setInputFields(newValue)
    onChangeInput(newValue)
  }
  const handleToDatepicker = (e) => {
    const newValue = {
      ...inputFields,
      validityTo: {
        ...inputFields.validityTo,
        value: e
      }
    }

    setInputFields(newValue)
    onChangeInput(newValue)
  }
  const handleCreatedFromDatepicker = (e) => {
    const newValue = {
      ...inputFields,
      createdDateFrom: {
        ...inputFields.createdDateFrom,
        value: e
      }
    }
    setInputFields(newValue)
    onChangeInput(newValue)
  }
  const handleCreatedToDatepicker = (e) => {
    const newValue = {
      ...inputFields,
      createdDateTo: {
        ...inputFields.createdDateTo,
        value: e
      }
    }
    setInputFields(newValue)
    onChangeInput(newValue)

  }
  const handleTxnFromDatepicker = (e) => {
    const newValue = {
      ...inputFields,
      txnDateFrom: {
        ...inputFields.txnDateFrom,
        value: e
      }
    }
    setInputFields(newValue)
    onChangeInput(newValue)
  }
  const handleTxnToDatepicker = (e) => {
    const newValue = {
      ...inputFields,
      tnxDateTo: {
        ...inputFields.txnDateTo,
        value: e
      }
    }
    setInputFields(newValue)
    onChangeInput(newValue)

  }

  const onPaymentInputFilter = (ins) => {
    setInputFields({
      ...ins
    })
  }
  context.addListenerPaymentInputFilter((inputs) => { onPaymentInputFilter(inputs) })
  const getProductsAndAccounts = async () => {

    const res = await ajax({
      method: 'GET',
      url: utils.urls.accessibleProduct,
      snackbar: enqueueSnackbar,
      hasToken: true
    })

    if (!res) return

    const serviceItems = res.data.map(service => {
      return {
        label: service.name,
        id: service.id,
        data: service
      }
    })

    const response = await ajax({
      method: 'GET',
      url: utils.urls.visiblePaymentGateway,
      snackbar: enqueueSnackbar,
      hasToken: true
    })

    if (!response) return

    const accounts = response.data.map(acc => {
      return {
        label: acc.name,
        id: acc.id,
        data: acc
      }
    })

    setInputFields({
      ...inputFields,
      accounts: {
        ...inputFields.accounts,
        items: accounts
      },
      product: {
        ...inputFields.product,
        items: serviceItems
      },

    })

  }

  const handleSelectDropDown = (service) => {
    const newValue = {
      ...inputFields,
      product: {
        ...inputFields.product,
        selected: service.id,
        value: service.name
      }
    }
    context.setPaymentInputFilter(newValue)
    onChangeInput(newValue)
  }

  const handlePGWDropDown = (pgw) => {
    const newValue = {
      ...inputFields,
      accounts: {
        ...inputFields.accounts,
        selected: pgw.id,
        value: pgw.name
      }
    }
    context.setPaymentInputFilter(newValue)
    onChangeInput(newValue)
  }
  const handleTypeDropDown = (type) => {
    const newValue = {
      ...inputFields,
      paymentTypes: {
        ...inputFields.paymentTypes,
        selected: type.type,
        value: type.type
      }
    }
    context.setPaymentInputFilter(newValue)
    onChangeInput(newValue)
  }


  useEffect(() => {
    if (showModal == true) {
      getProductsAndAccounts()
    }
  }, [showModal])


  const fetchCurrency = async () => {

    const response = await ajax({
      method: 'GET',
      url: utils.urls.searchCurrency(inputCurrencyValue),
      hasToken: true,
      snackbar: enqueueSnackbar
    })
    setCurrencyOptions(response.data)
  }

  const fetchUser = async () => {

    const response = await ajax({
      method: 'GET',
      url: utils.urls.searchUser + `?username=${inputUserValue}`,
      hasToken: true,
      snackbar: enqueueSnackbar
    })
    setUserOptions(response.data)
  }

  const fetchApprovedUser = async () => {

    const response = await ajax({
      method: 'GET',
      url: utils.urls.searchUser + `?username=${inputApproveUserValue}`,
      hasToken: true,
      snackbar: enqueueSnackbar
    })
    setApproveUserOptions(response.data)
  }

  const fetchOffice = async () => {

    const response = await ajax({
      method: 'GET',
      url: utils.urls.searchOffice + `?name=${inputOfficeValue}&code=${inputOfficeValue}`,
      hasToken: true,
      snackbar: enqueueSnackbar
    })
    setOfficeOptions(response.data)
  }

  const handleCheckbox = (e) => {
    if (e.target.checked === true) {

      const newValue = {
        ...inputFields,
        autoAmount: {
          ...inputFields.autoAmount,
          value: 'true'
        }
      }
      setInputFields(newValue)
      onChangeInput(newValue)

    } else {
      const newValue = {
        ...inputFields,
        autoAmount: {
          ...inputFields.autoAmount,
          value: ''
        }
      }
      setInputFields(newValue)
      onChangeInput(newValue)
    }
  }


  const handleAutoBookingCheckbox = (e) => {
    if (e.target.checked === true) {

      const newValue = {
        ...inputFields,
        autoBooking: {
          ...inputFields.autoBooking,
          value: 'true'
        }
      }
      setInputFields(newValue)
      onChangeInput(newValue)

    } else {
      const newValue = {
        ...inputFields,
        autoBooking: {
          ...inputFields.autoBooking,
          value: ''
        }
      }
      setInputFields(newValue)
      onChangeInput(newValue)
    }
  }


  useEffect(() => {
    if (showModal == true)
      fetchCurrency()
  }, [inputCurrencyValue])

  useEffect(() => {
    if (showModal == true)
      fetchUser()
  }, [inputUserValue])

  useEffect(() => {
    if (showModal == true)
      fetchApprovedUser()
  }, [inputApproveUserValue])

  useEffect(() => {
    if (showModal == true)
      fetchOffice()
  }, [inputOfficeValue])


  return (
    <div className="inputs-container">
      <div>
        <label>Transaction ID</label>
        <div className="field">
          <Input inputField={inputFields.id} onChange={handleChange} />
        </div>
      </div>
      <div>
        <label>payment gateway</label>
        <div className="field">
          <Input inputField={inputFields.accounts} onChange={handleChange} onClickDropdownItem={handlePGWDropDown} />
        </div>
      </div>
      <div>
        <label>product</label>
        <div className="field">
          <Input inputField={inputFields.product} onChange={handleChange} onClickDropdownItem={handleSelectDropDown} />
        </div>
      </div>
      <div>
        <label>payment type</label>
        <div className="field">
          <Input inputField={inputFields.paymentTypes} onChange={handleChange} onClickDropdownItem={handleTypeDropDown} />
        </div>
      </div>
      <div style={{ display: "flex", gap: "7px" }}>
        <div style={{ width: "50%" }}>
          <label>amout from</label>
          <div className="field">
            <Input inputField={inputFields.amountFrom} onChange={handleChange} />
          </div>
        </div>
        <div style={{ width: "50%" }}>
          <label>amount to</label>
          <div className="field">
            <Input inputField={inputFields.amountTo} onChange={handleChange} />
          </div>
        </div>
      </div>


      <div>
        <label>masked pan</label>
        <div className="field">
          <Input inputField={inputFields.maskedPan} onChange={handleChange} />
        </div>
      </div>
      <div>
        <label>payment reference</label>
        <div className="field">
          <Input inputField={inputFields.paymentReference} onChange={handleChange} />
        </div>
      </div>
      <div>
        <label>RRN</label>
        <div className="field">
          <Input inputField={inputFields.rrn} onChange={handleChange} />
        </div>
      </div>
      <div>
        <label>trace id</label>
        <div className="field">
          <Input inputField={inputFields.traceId} onChange={handleChange} />
        </div>
      </div>
      <div>
        <label>refrence</label>
        <div className="field">
          <Input inputField={inputFields.reference} onChange={handleChange} />
        </div>
      </div>
      <div>
        <label>name</label>
        <div className="field">
          <Input inputField={inputFields.primaryContact} onChange={handleChange} />
        </div>
      </div>
      <div>
        <label>email</label>
        <div className="field">
          <Input inputField={inputFields.email} onChange={handleChange} />
        </div>
      </div>
      <div>
        <label>mobile</label>
        <div className="field">
          <Input inputField={inputFields.mobile} onChange={handleChange} />
        </div>
      </div>
      <div>
        <label>Purchase ID</label>
        <div className="field">
          <Input inputField={inputFields.purchaseId} onChange={handleChange} />
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <label style={{ marginTop: "7px" }}>auto amount</label>
        <div className="field">
          <input value="autoAmount" title="auto amount" type="checkbox" checked={inputFields.autoAmount.value === 'true' ? true : false} onChange={handleCheckbox} />
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <label style={{ marginTop: "7px" }}>auto booking</label>
        <div className="field">
          <input value="autoAmount" title="auto amount" type="checkbox" checked={inputFields.autoBooking.value === 'true' ? true : false} onChange={handleAutoBookingCheckbox} />
        </div>
      </div>
      <div style={{ display: "flex", gap: "28px" }}>
        {/* <label>mobile</label> */}
        <div className="field">
          <div className="datePicker">
            <LocalizationProvider dateAdapter={AdapterDayjs}>

              <DateTimePicker
                label="validity From"
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
                value={inputFields.validityFrom.value}
                onChange={handleFromDatepicker}
                ampm={false}
                format="YYYY-MM-DD HH:mm"

              />
            </LocalizationProvider>
          </div>
        </div>
        <div className="field">
          <div className="datePicker">
            <LocalizationProvider dateAdapter={AdapterDayjs}>

              <DateTimePicker
                label="validity To"
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
                value={inputFields.validityTo.value}
                onChange={handleToDatepicker}
                ampm={false}
                format="YYYY-MM-DD HH:mm"
              />
            </LocalizationProvider>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", gap: "28px" }}>
        {/* <label>mobile</label> */}
        <div className="field">
          <div className="datePicker">
            <LocalizationProvider dateAdapter={AdapterDayjs}>

              <DateTimePicker
                label="created date from"
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
                value={inputFields.createdDateFrom.value}
                onChange={handleCreatedFromDatepicker}
                ampm={false}
                format="YYYY-MM-DD HH:mm"
              />
            </LocalizationProvider>
          </div>
        </div>
        <div className="field">
          <div className="datePicker">
            <LocalizationProvider dateAdapter={AdapterDayjs}>

              <DateTimePicker
                label="created date to"
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
                value={inputFields.createdDateTo.value}
                onChange={handleCreatedToDatepicker}
                ampm={false}
                format="YYYY-MM-DD HH:mm"
              />
            </LocalizationProvider>
          </div>
        </div>
      </div>



      <div style={{ display: "flex", gap: "28px" }}>
        {/* <label>mobile</label> */}
        <div className="field">
          <div className="datePicker">
            <LocalizationProvider dateAdapter={AdapterDayjs}>

              <DateTimePicker
                label="Transaction date from"
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
                value={inputFields.txnDateFrom.value}
                onChange={handleTxnFromDatepicker}
                ampm={false}
                format="YYYY-MM-DD HH:mm"
              />
            </LocalizationProvider>
          </div>
        </div>
        <div className="field">
          <div className="datePicker">
            <LocalizationProvider dateAdapter={AdapterDayjs}>

              <DateTimePicker
                label="Transaction date to"
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
                value={inputFields.txnDateFrom.value}
                onChange={handleTxnToDatepicker}
                ampm={false}
                format="YYYY-MM-DD HH:mm"
              />
            </LocalizationProvider>
          </div>
        </div>
      </div>



      <div style={{ marginTop: '10px' }}>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={statusOptions}
          sx={{ width: "100%" }}
          renderInput={(params) => <TextField {...params} label="Status" />}
          onChange={(event, newValue) => {
            setInputFields({
              ...inputFields,
              status: {
                ...inputFields.status,
                selected: newValue?.label,
                value: newValue?.label
              }
            })
            onChangeInput({
              ...inputFields,
              status: {
                ...inputFields.status,
                selected: newValue?.label,
                value: newValue?.label
              }
            })
          }}
        />
      </div>
      <div style={{ marginTop: "10px", marginBottom: "5px" }}>
        <Autocomplete
          sx={{ width: "100%" }}
          renderInput={(params) => <TextField {...params} label="Currency" />}
          getOptionLabel={(option) => option ? option.code : ''}
          options={currencyOptions}
          autoComplete
          includeInputInList
          filterSelectedOptions
          value={inputFields.currency.value}
          noOptionsText="No currency"
          onChange={(event, newValue) => {
            setCurrencyValue(newValue?.id);
            setInputFields({
              ...inputFields,
              currency: {
                ...inputFields.currency,
                selected: newValue?.id,
                value: newValue
              }
            })
            onChangeInput({
              ...inputFields,
              currency: {
                ...inputFields.currency,
                selected: newValue?.id,
                value: newValue
              }
            })
          }}
          onInputChange={(event, newInputValue) => {
            if (newInputValue.trim())
              setInputCurrencyValue(newInputValue)
          }}
          renderOption={(props, option) => <li {...props}>{option.code}</li>}

        />
      </div>
      <div style={{ marginTop: "10px", marginBottom: "5px" }}>
        <Autocomplete
          sx={{ width: "100%" }}
          renderInput={(params) => <TextField {...params} label="Created user" />}
          getOptionLabel={(option) => option ? option.username : ''}
          options={userOptions}
          autoComplete
          includeInputInList
          filterSelectedOptions
          value={inputFields.createdUser.value}
          noOptionsText="No user"
          onChange={(event, newValue) => {
            setUserValue(newValue?.id);
            setInputFields({
              ...inputFields,
              createdUser: {
                ...inputFields.createdUser,
                selected: newValue?.id,
                value: newValue
              }
            })
            onChangeInput({
              ...inputFields,
              createdUser: {
                ...inputFields.createdUser,
                selected: newValue?.id,
                value: newValue
              }
            })
          }}
          onInputChange={(event, newInputValue) => {
            if (newInputValue.trim())
              setInputUserValue(newInputValue)
          }}
          renderOption={(props, option) => <li {...props}>{option.username}</li>}

        />
      </div>
      <div style={{ marginTop: "10px", marginBottom: "5px" }}>
        <Autocomplete
          sx={{ width: "100%" }}
          renderInput={(params) => <TextField {...params} label="Approved By" />}
          getOptionLabel={(option) => option ? option.username : ''}
          options={approveUserOptions}
          autoComplete
          includeInputInList
          filterSelectedOptions
          value={inputFields.approvedUsers.value}
          noOptionsText="No user"
          onChange={(event, newValue) => {
            setApproveUserValue(newValue?.id);
            setInputFields({
              ...inputFields,
              approvedUsers: {
                ...inputFields.approvedUsers,
                selected: newValue?.id,
                value: newValue
              }
            })
            onChangeInput({
              ...inputFields,
              approvedUsers: {
                ...inputFields.approvedUsers,
                selected: newValue?.id,
                value: newValue
              }
            })
          }}
          onInputChange={(event, newInputValue) => {
            if (newInputValue.trim())
              setInputApproveUserValue(newInputValue)
          }}
          renderOption={(props, option) => <li {...props}>{option.username}</li>}

        />
      </div>

      <div style={{ marginTop: "10px", marginBottom: "5px" }}>
        <Autocomplete
          sx={{ width: "100%" }}
          renderInput={(params) => <TextField {...params} label="Created office" />}
          getOptionLabel={(option) => option ? option.name + ' - ' + option.code : ''}
          options={officeOptions}
          autoComplete
          filterSelectedOptions
          value={inputFields.createdOffice.value}
          noOptionsText="No office"
          onChange={(event, newValue) => {
            setOfficeValue(newValue?.id);
            setInputFields({
              ...inputFields,
              createdOffice: {
                ...inputFields.createdOffice,
                selected: newValue?.id,
                value: newValue
              }
            })
            onChangeInput({
              ...inputFields,
              createdOffice: {
                ...inputFields.createdOffice,
                selected: newValue?.id,
                value: newValue
              }
            })
          }}
          onInputChange={(event, newInputValue) => {
            if (newInputValue.trim())
              setInputOfficeValue(newInputValue)
          }}
          renderOption={(props, option) => <li {...props}>{option.name + ' - ' + option.code}</li>}

        />
      </div>
    </div>
  )


}

const Footer = ({ onFilter, closeModal, inputs }) => {
  // const [input, setInput] = useState(inputs)
  return (
    <div className="btns-container">
      <button className="clear" onClick={() => { context.clearInputFields(); onFilter(context.getPaymentInputFilter()); closeModal() }}>Clear Filters</button>
      <button className="cancel" onClick={closeModal} >Cancel</button>
      <button className="apply" onClick={() => { onFilter(inputs); closeModal() }} >Apply Filters</button>
    </div>
  )
}
class PaymentModal extends Component {
  state = {
    open: false,
    inputs: {}
  }

  openModal = () => this.setState({ open: true })
  closeModal = () => this.setState({ open: false })
  clearDate = () => { return '' }

  onChangeInputs = (inputs) => this.setState({ inputs: inputs })

  render() {
    return (
      <BaseModal open={this.state.open} closeModal={this.closeModal} footer={Footer({ onFilter: this.props.onFilter, closeModal: this.closeModal, inputs: this.state.inputs })}>
        <Content
          {...this.props}
          showModal={this.state.open}
          closeModal={this.closeModal}
          onChangeInput={this.onChangeInputs}
        />
      </BaseModal>
    )
  }
}

export default PaymentModal
